import { Label } from "@/components/ui/baseUi/label"
import { UserCellSkeleton } from "@/components/ui/layout/table/userCell"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"

type SearchStaffInputSkeletonProps = {
  className?: string
  label?: string
  isRequiredInput?: boolean
} & React.ComponentProps<"div">

export function SearchStaffInputSkeleton({
  className,
  label,
  isRequiredInput,
  ...props
}: SearchStaffInputSkeletonProps) {
  return (
    <div className={cn("flex w-full flex-col gap-3", className)} {...props}>
      {label && (
        <Label className="label-small text-textDefault-body">
          {label.toUpperCase()}
          {isRequiredInput && (
            <Text fontStyle="LL" className="text-textError">
              {" "}
              *
            </Text>
          )}
        </Label>
      )}

      <div className="grid grid-cols-2 gap-2">
        {Array.from({ length: 6 }).map((_, index) => (
          <UserCellSkeleton
            key={index}
            subtitle={true}
            avatarSize="size-16"
            className="flex cursor-pointer justify-center rounded-2xl border border-borderDefault px-2 py-3"
          />
        ))}
      </div>
    </div>
  )
}
